import { AxiosStatic, AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { Cycle } from '@/types/cycle';
import { UpgradeReportType } from '@/types/upgradereporttype';
import { UpgradeJobType } from '@/types/upgradejob';

export default class UpgradeResource extends FBaseService {
  public async loadPreviousJobReports(fiId: string,
    reportType: UpgradeReportType,
    coreProcessingDate?: string): Promise<any[]> {
    let url = `/api/krp/admin/upgrade-report/${fiId}/versions/${reportType}`;
    if (coreProcessingDate) {
      url += `?coreProcessingDate=${coreProcessingDate}`;
    }

    const response: AxiosResponse = await this.apiClient.get(url);

    return response.data.data;
  }

  public async downloadPreviousReportVersionOfType(fiId: string,
    reportType: string,
    reportS3Key: string,
    versionId: string,
    coreProcessingDate?: string): Promise<any> {
    let url = `/api/krp/admin/upgrade-report/${fiId}/${reportType}/${versionId}`;
    if (coreProcessingDate) {
      url += `?coreProcessingDate=${coreProcessingDate}`;
    }

    const response: AxiosResponse = await this.apiClient.get(url, { responseType: 'blob' });

    return response.data;
  }

  public async runSelectedUpgradeJob(runReportUrl: string, runReportRequestBody: any): Promise<any> {
    const response: AxiosResponse = await this.apiClient.post(runReportUrl, runReportRequestBody);

    return response.data.data;
  }

  public async monitorJobStatusUntilCompleted(id: string): Promise<any[]> {
    const url = `/api/krp/admin/upgrade/${id}`;

    const response: AxiosResponse = await this.apiClient.get(url);

    return response.data.data;
  }
}
